import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoader = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.19995 16C3.19995 8.93076 8.93071 3.2 16 3.2C17.2363 3.2 18.4292 3.37483 19.5564 3.70012C20.4054 3.94512 21.2923 3.45547 21.5373 2.60645C21.7823 1.75744 21.2926 0.870569 20.4436 0.625572C19.0309 0.217909 17.5395 0 16 0C7.17672 0 0.0215652 7.14185 0 15.96V16.04C0.0215561 24.8544 7.17069 31.994 15.9888 32C15.9925 32 15.9962 32 16 32C16.0037 32 16.0074 32 16.0111 32C24.8425 31.994 32 24.8328 32 16C32 14.4605 31.7821 12.9691 31.3744 11.5564C31.1294 10.7074 30.2425 10.2177 29.3935 10.4627C28.5445 10.7077 28.0549 11.5946 28.2998 12.4436C28.6251 13.5708 28.8 14.7636 28.8 16C28.8 23.0692 23.0692 28.8 16 28.8C8.93071 28.8 3.19995 23.0692 3.19995 16Z",
		fill: "#0161FE"
	})
});
const ForwardRef = forwardRef(SvgLoader);
export default ForwardRef;
